import { render, staticRenderFns } from "./changeIdentity.vue?vue&type=template&id=2320f277&scoped=true"
import script from "./changeIdentity.vue?vue&type=script&lang=js"
export * from "./changeIdentity.vue?vue&type=script&lang=js"
import style0 from "./changeIdentity.vue?vue&type=style&index=0&id=2320f277&prod&scoped=true&lang=css"
import style1 from "./changeIdentity.vue?vue&type=style&index=1&id=2320f277&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320f277",
  null
  
)

export default component.exports